export const api = "https://magdalena.onrender.com";
// export const api = "http://localhost:10000";
